// Based on https://github.com/reactjs/react-rails/blob/83b6175460b6fd19d667854ebea4777d8c73705a/react_ujs/index.js

import React from 'react';
import ReactDOM from 'react-dom';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/utils/flatten_registry'. 'app/webpack/javascripts/shared/utils/flatten_registry.js' implicitly has an 'any' type.
import { flattenRegistry } from 'shared/utils/flatten_registry';
import timeInDevelopment from 'shared/utils/time_in_development';
import { ThemeProvider } from 'styled-components';
import documentReady from 'document-ready';
import { createTheme } from '@mui/material/styles';

const CLASS_NAME_ATTR = 'data-react-class';
const PROPS_ATTR = 'data-react-props';

let mountedComponentsCount = 0;

// eslint-disable-next-line flowtype/no-weak-types
type Component = any;

type ComponentRegistry = {
  [key: string]: Component;
};

class Mounter {
  static mountWhenReady(componentRegistry: ComponentRegistry) {
    documentReady(() => {
      new Mounter(componentRegistry).mountAll();
    });
  }

  componentRegistry: ComponentRegistry;
  // @ts-expect-error - TS2564 - Property '_flattenedRegistry' has no initializer and is not definitely assigned in the constructor.
  _flattenedRegistry: {
    [key: string]: Component;
  };

  constructor(componentRegistry: ComponentRegistry) {
    this.componentRegistry = componentRegistry;
  }

  findDomNodes = () => {
    return this.reactNodes().filter((reactNode) => {
      const componentName = reactNode.getAttribute(CLASS_NAME_ATTR);
      return this.registeredComponentNames().includes(componentName);
    });
  };

  reactNodes(selector = '') {
    // It's possible in certain browsers for nodes to not have the iterable methods, so coerce into an Array
    return Array.prototype.slice.call(
      document.querySelectorAll(`${selector} [${CLASS_NAME_ATTR}]`)
    );
  }

  registeredComponentNames = (): Array<string> => {
    return Object.keys(this.flattenedRegistry());
  };

  getComponentConstructor = (className: string) => {
    return this.flattenedRegistry()[className];
  };

  flattenedRegistry = (): {
    [key: string]: Component;
  } => {
    this._flattenedRegistry =
      this._flattenedRegistry || flattenRegistry(this.componentRegistry);
    return this._flattenedRegistry;
  };

  mount = (node: HTMLElement) => {
    mountedComponentsCount += 1;

    const className = node.getAttribute(CLASS_NAME_ATTR);

    if (!className) {
      throw `Unable to find className`;
    }

    timeInDevelopment(
      `Component mount #${mountedComponentsCount}: ${className}`,
      () => {
        const constructor = this.getComponentConstructor(className);
        const propsJson = node.getAttribute(PROPS_ATTR);
        const props = propsJson && JSON.parse(propsJson);

        const themeName =
          (window.Greenhouse && window.Greenhouse.currentThemeName) || '';

        const element = React.createElement(constructor, props);
        const materialUITheme = createTheme();

        ReactDOM.render(
          <ThemeProvider theme={{ ...materialUITheme, name: themeName }}>
            {element}
          </ThemeProvider>,
          node
        );
      }
    );
  };

  mountAll = () => this.findDomNodes().forEach(this.mount);
}

export default Mounter;
